import { graphql } from '@/gql'

export const FORM_FIELDS_QUERY = graphql(`
  query allFormFields(
    $objectTypes: [String!]
    $excludeFields: [String!] = ["table"]
    $orderBy: [FormFieldsOrderBy!] = [ORDER_ASC]
    $or: [FormFieldFilter!]
  ) {
    formFields(
      filter: {
        and: [
          { active: { equalTo: true } }
          { objectType: { in: $objectTypes } }
          { fieldType: { notIn: $excludeFields } }
        ]
        or: $or
      }
      orderBy: $orderBy
    ) {
      edges {
        node {
          ...FormField
        }
      }
    }
  }
`)

export const EMPLOYEE_FORM_FIELDS_QUERY = graphql(`
  query allEmployeeFormFields {
    formFields(
      filter: {
        and: [
          { active: { equalTo: true } }
          { objectType: { equalTo: "employee" } }
          { fieldType: { equalTo: "employee" } }
        ]
      }
      orderBy: NAME_ASC
    ) {
      edges {
        node {
          ...FormField
        }
      }
    }
  }
`)

export const FORM_FIELDS_WITH_ENTRIES_QUERY = graphql(`
  query allFormFieldsWithEntries($employeeId: UUID!, $objectTypes: [String!]) {
    formFields(
      filter: {
        and: [
          { active: { equalTo: true } }
          { objectType: { in: $objectTypes } }
        ]
      }
      orderBy: [ORDER_ASC]
    ) {
      nodes {
        id
        formFieldEntries(
          first: 1
          condition: { active: true, employeeId: $employeeId }
          orderBy: CREATED_AT_DESC
        ) {
          nodes {
            humanReadableValue
          }
        }
      }
    }
  }
`)

export const EMPLOYEE_FIELD_FORM_FIELD_ENTRIES = graphql(`
  query employeeFieldFormFieldEntries($userId: UUID!, $formFieldIds: [UUID!]) {
    formFieldEntries(
      filter: {
        active: { equalTo: true }
        userId: { equalTo: $userId }
        formFieldId: { in: $formFieldIds }
      }
    ) {
      nodes {
        value
      }
    }
  }
`)

export const FORM_FIELD_QUERY = graphql(`
  query getFormField($id: UUID!) {
    formFieldById(id: $id) {
      ...FormField
    }
  }
`)

export const VALIDATE_FORM_FIELD_ENTRY_UNIQUENESS = graphql(`
  query validateFormFieldEntryUniqueness(
    $userId: UUID
    $formFieldId: UUID
    $value: String
  ) {
    validateFormFieldEntryUniqueness(
      userId: $userId
      formFieldId: $formFieldId
      value: $value
    )
  }
`)
export const FORM_FIELD_ENTRY_COUNT = graphql(`
  query formFieldEntryCount($employeeIds: [UUID]!) {
    formFieldEntryCount(argEmployeeIds: $employeeIds) {
      nodes {
        count
        value
      }
    }
  }
`)

export const FORM_FIELD_ENTRIES = graphql(`
  query formFieldEntries($id: UUID!, $employeeIds: [UUID!]!) {
    formFieldById(id: $id) {
      id
      objectType
      fieldType
      localizedName
      localizedHelpText
      defaultValue
      required
      sensitive
      order
      metadata
      fieldGroupId
      productTypeIds
      formFieldOptions(orderBy: ORDER_ASC, condition: { active: true }) {
        nodes {
          id
          localizedValue
          value
          order
          predefined
        }
      }
      formFieldEntries(
        filter: {
          active: { equalTo: true }
          value: { isNull: false }
          employeeId: { in: $employeeIds }
        }
        orderBy: CREATED_AT_DESC
      ) {
        nodes {
          ...FormFieldEntry
        }
      }
    }
  }
`)

export const FORM_FIELDS = graphql(`
  query allFormFields2($active: Boolean = true, $filter: FormFieldFilter) {
    formFields(condition: { active: $active }, filter: $filter) {
      nodes {
        ...FormField
      }
    }
  }
`)

export const FORM_FIELDS_BY_ID = graphql(`
  query formFieldsNameOnly($formFieldIds: [UUID!]!) {
    formFields(
      condition: { active: true }
      filter: { id: { in: $formFieldIds } }
    ) {
      nodes {
        id
        localizedName
      }
    }
  }
`)

export const FORM_FIELD_EXISTS = graphql(`
  query formFieldExists($name: String!, $id: UUID) {
    formFields(
      filter: {
        objectType: { equalTo: "employee" }
        active: { equalTo: true }
        name: { equalTo: $name }
        id: { notEqualTo: $id }
      }
    ) {
      totalCount
    }
  }
`)

export const FORM_FIELD_SEARCH_SUGGESTIONS = graphql(`
  query formFieldSearchSuggestions($searchQuery: String!, $companyId: UUID!) {
    formFields(
      condition: { active: true, companyId: $companyId, objectType: "employee" }
      filter: { localizedName: { includesInsensitive: $searchQuery } }
    ) {
      nodes {
        id
        localizedName
        fieldGroupId
      }
    }
  }
`)

export const FORM_FIELD_CONTACTS = graphql(`
  query formFieldContacts($id: UUID!) {
    formFieldById(id: $id) {
      contacts {
        nodes {
          id
          firstName
          lastName
          fullName
          email
          emailWork
          mobile
          mobilePrivate
          logo
          jobPositionTitle
        }
      }
    }
  }
`)

export const USE_FORM_FIELDS_QUERY = graphql(`
  query useFormFieldsQuery(
    $companyId: UUID
    $filter: FormFieldFilter
    $getFieldEntries: Boolean!
    $orderBy: [FormFieldsOrderBy!]
    $fieldEntriesFilter: FormFieldEntryFilter
  ) {
    formFields(
      condition: { active: true, companyId: $companyId }
      filter: $filter
      orderBy: $orderBy
    ) {
      nodes {
        ...UseFormField
      }
    }
  }
`)
